import React, { useState, forwardRef, useEffect, useRef } from "react";
import { Typography, Paper, Grid, FormControl } from "@material-ui/core";
import useStyles from "../../styles/deviceTaskStyle";
import SelectOrientation from "./SelectOrientation";
import SelectDate from "../device/SelectDate";
import { useTranslation } from "../../langs/useTranslation";
import { Formik, Form } from "formik";
import CommandConfirmDialog from "../commons/CommandConfirmDialog";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import * as localforage from "localforage";
import { rotationAPI } from "../../apis/deviceControlApi";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";
import {
  handleClose,
  handleHasResponseStatus
} from "../../helpers/commandConfirmationDialogAction";
import { rotationValuesSchema } from "../../config/singleDeviceTaskValuesSchema";
import { DateTimeComparisonText } from "../commons/ValidationText";
import { getDeviceTwinsApi } from "@/apis/deviceDetailAPI";
import { getTwinsDesiredOrReportedByLastUpdated } from "@/helpers/utils";

const RotationSingleForm = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    executeType,
    deviceId,
    devices,
    storedDatePickerValueToLocalforageName,
    resetAllStoredValueInLocalforage,
    successfulText,
    dispatch
  } = props;
  const { t } = useTranslation("task");
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [datetime, setDatetime] = useState(true);
  const [isExecuting, setIsExecuting] = useState(false);
  const formRef = useRef();

  const rotationInitialValues = {
    // orientation: sessionStorage.getItem("orientation_" + deviceId) || "",
    orientation: "",
    date: ""
  };

  const handleExecuteAction = async () => {
    setIsExecuting(true);
    // Execute the task after modal opened and the confirm button clicked
    const orientation = values.orientation;
    const selectedIds = [];
    const company_id = await localforage.getItem("companyId");
    const responseStatus = await rotationAPI(
      "company",
      company_id,
      [deviceId],
      undefined,
      undefined,
      executeType,
      datetime,
      orientation,
      t,
      successfulText
    );
    if (responseStatus) {
      handleHasResponseStatus(setOpen, resetAllStoredValueInLocalforage);
      setIsExecuting(false);
    }
    dispatch({ type: "stopLoading" });
  };

  useEffect(() => {
    getDeviceTwinsApi(deviceId).then(({data}) => {
      const reported = data.properties.reported
      if (formRef.current) {
        formRef.current.setFieldValue(
          "orientation", 
          getTwinsDesiredOrReportedByLastUpdated(data.properties, 'screen_rotation')
        )
      }
      // setValues(values => {
      //   return {
      //     ...values,
      //     orientation: reported.screen_rotation
      //   }
      // })
    })
  }, [])

  return (
    <Formik
      innerRef={formRef}
      initialValues={rotationInitialValues}
      validationSchema={rotationValuesSchema}
      onSubmit={async values => {
        dispatch({ type: "showLoading" });
        setValues(values);
        const datetime =
          values.date === "immediately"
            ? "immediately"
            : await localforage.getItem(storedDatePickerValueToLocalforageName);
        setDatetime(datetime);
        if (datetime) {
          setOpen(true);
        } else {
          dispatch({ type: "stopLoading" });
        }
      }}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormControl fullWidth={true} ref={ref}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <Typography variant="h6">
                    {t("task.step")}1. {t("task.selectAnOrientation")}
                  </Typography>
                  <SelectOrientation
                    formikName="orientation"
                    formikOnChange={handleChange}
                    formikValue={values.orientation}
                    formikError={
                      errors.orientation &&
                      touched.orientation &&
                      errors.orientation
                    }
                  />
                </Paper>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <Typography variant="h6">
                    {t("task.step")}2. {t("task.selectDate")}
                  </Typography>
                  <SelectDate
                    storedDatePickerValueToLocalforageName={
                      storedDatePickerValueToLocalforageName
                    }
                    formikName="date"
                    formikOnChange={handleChange}
                    formikValue={values.date}
                    formikError={errors.date && touched.date && errors.date}
                  />
                  {!datetime ? <DateTimeComparisonText /> : ""}
                </Paper>
                <div className="submit-back-btn-wrap">
                  <StyledSubmitBtn
                    startIcon={<SendRoundedIcon />}
                    btnText={t("btn.confirmBtn")}
                    btnColor="primary"
                    type="submit"
                  />
                  <BackBtn />
                  <CommandConfirmDialog
                    isExecuting={isExecuting}
                    okBtnOnClick={handleExecuteAction}
                    backBtnOnClick={() =>
                      handleClose(setOpen, dispatch, setIsExecuting)
                    }
                    open={open}
                    dialogTitle={t("task.rotationName")}
                    dialogContent={t("modal.rotationDescription")}
                  />
                </div>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}
    </Formik>
  );
});

export default RotationSingleForm;
